const positiveEventsOptionModal = $('#positive-events-option-modal');
const negativeEventsOptionModal = $('#negative-events-option-modal');
const otherEventsOptionModal = $('#other-events-option-modal');

const positiveEventsContainerModal = $('#positive-events-container-modal');
const negativeEventsContainerModal = $('#negative-events-container-modal');
const otherEventsContainerModal = $('#other-events-container-modal');

window.toggleModalFilters = () => {
    if (positiveEventsOptionModal.is(':checked')) {
        positiveEventsContainerModal.slideDown();
    } else {
        positiveEventsContainerModal.slideUp();
    }

    if (negativeEventsOptionModal.is(':checked')) {
        negativeEventsContainerModal.slideDown();
    } else {
        negativeEventsContainerModal.slideUp();
    }

    if (otherEventsOptionModal.is(':checked')) {
        otherEventsContainerModal.slideDown();
    } else {
        otherEventsContainerModal.slideUp();
    }
}

window.print = () => {
    $('.toast').toast('show');
}